/**
 * Reports: the catalogue, the report screen, its toolbar, charts, KPI tiles
 * and table. Report titles, KPI and column labels, filters and sorts come from
 * the API and are not in here. Conventions: see `common.ts`.
 */
const reporting: Record<string, string> = {
  'pages.merchant_title': 'Reports',
  'pages.merchant_description': 'Every figure on your dashboard, with the detail behind it.',
  'pages.platform_title': 'Reports',
  'pages.platform_description': 'The whole platform, and every merchant in it.',
  'pages.all_reports': 'All reports',

  'export.csv': 'CSV',
  'export.csv_hint': 'Every row, nothing lost',
  'export.excel': 'Excel-ready CSV',
  'export.excel_hint': 'Opens in Excel without an import wizard',
  'export.pdf': 'PDF',
  'export.pdf_hint': 'A printable summary, Latin script only',

  'views.title': 'Saved views',
  'views.empty': 'Save the window and filters you are looking at, and come back to them in a click.',
  'views.save_current': 'Save this view',
  'views.name_label': 'View name',
  'views.name_placeholder': 'Last quarter, by reason',
  'views.saved': 'Saved as {name}.',
  'views.deleted': 'Removed {name}.',
  'views.delete': 'Delete saved view {name}',

  'index.search_label': 'Search reports',
  'index.search_placeholder': 'Search reports…',
  'index.no_matches_description': 'Try a different word, or pick another category.',

  'index.load_error': 'The report catalogue could not be loaded.',
  'index.loading': 'Loading reports…',
  'index.no_access': 'You do not have permission to view any reports yet. Ask an administrator for access.',

  'view.load_error': 'This report could not be loaded. Try again in a moment.',
  'view.loading': 'Crunching the numbers…',
  'view.date_range': '{from} – {to}',
  'view.records_one': '{total} record',
  'view.records_other': '{total} records',
  'view.export_error': 'The export could not be generated. Try a shorter window.',

  'range.today': 'Today',
  'range.yesterday': 'Yesterday',
  'range.7d': '7 days',
  'range.30d': '30 days',
  'range.90d': '90 days',
  'range.mtd': 'This month',
  'range.ytd': 'This year',
  'range.12m': '12 months',
  'range.all': 'All time',

  'toolbar.from': 'From',
  'toolbar.to_separator': 'to',
  'toolbar.to': 'To',
  'toolbar.sort_by': 'Sort by',
  'toolbar.filter_any': '{label}: any',
  'toolbar.search_label': 'Search this report',

  'kpi.no_prior_data': 'no prior data',

  'chart.empty': 'Nothing to plot in this window.',
  'chart.click_to_open': 'Click to open',
  'chart.other': 'Other ({count})',

  'table.empty': 'Nothing to show for these filters.',
  'table.total': 'Total',
  'table.summary_platform': '{total} rows in this report, scoped to the whole platform.',
  'table.summary_merchant': '{total} rows in this report, scoped to your business.',
};

export default reporting;
